<template>
    <!-- 报表管理－页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'statementPage')">
            <div slot="header" v-if="getBtnByAuth('ticketBraceletExport') || getBtnByAuth('braceletGateExport') || getBtnByAuth('stateExport')">
                <a-tabs :defaultActiveKey='defaultActiveKey' @change="callback" class="tradeRecord_tab">
                    <a-tab-pane v-if="getBtnByAuth('ticketBraceletExport')" tab="票券手环绑定信息" key="1" forceRender></a-tab-pane>
                    <a-tab-pane v-if="getBtnByAuth('braceletGateExport')" tab="手环-闸机对应信息" key="2"></a-tab-pane>
                    <a-tab-pane v-if="getBtnByAuth('stateExport')" tab="数据统计" key="3"></a-tab-pane>
                </a-tabs>
                <a-form :form="form" layout="inline" class="store-one-form">
                    <div v-show="type == 3">
                        <a-form-item label="日期">
                            <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['useDate',{initialValue: [moment(),moment()]}]" />
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button @click="searchBracelet" class="mr8" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </div>
                    <div v-show="type != 3">
                        <a-form-item label="消费时间">
                            <a-range-picker style="width:282px" showTime format="YYYY/MM/DD HH:mm" v-decorator="['consumeTime',{initialValue: initialValueDate}]" />
                        </a-form-item>
                        <a-form-item label="票券名称" v-show="type == 1">
                            <a-input placeholder="请输入" v-decorator="['ticketName']"></a-input>
                        </a-form-item>
                        <a-form-item label="会员手机号">
                            <a-input placeholder="请输入" v-decorator="['account']"></a-input>
                        </a-form-item>
                        <a-form-item label="手环码">
                            <a-input placeholder="请输入" v-decorator="['braceletNo']"></a-input>
                        </a-form-item>
                        <a-form-item label="状态" v-show="type == 2">
                            <a-select allowClear placeholder="请选择" v-decorator="['useType']">
                                <a-select-option value="0" >绑定</a-select-option>
                                <a-select-option value="2" >出场</a-select-option>
                                <a-select-option value="1" >入场</a-select-option>
                                <a-select-option value="-1" >其他</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="操作人" v-show="type == 1">
                            <a-input placeholder="请输入" v-decorator="['cashier']"></a-input>
                        </a-form-item>
                        <a-form-item label="场地名称">
                            <a-select allowClear placeholder="请选择" v-decorator="['shopId']">
                                <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button :loading="loading" @click="search" class="mr8" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </div>
                </a-form>
            </div>
            <div class="wrap-container-in" v-if="getBtnByAuth('ticketBraceletExport') || getBtnByAuth('braceletGateExport') || getBtnByAuth('stateExport')">
                <div v-if="type == 1">
                    <template>
                        <span>该时间段绑定手环总数：{{bindNum}}</span>
                        <a-button class="float-right mb16" @click="exportExcel()" :loading="loading">导出excel</a-button>
                    </template>
                    <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                        <span slot="braceletNo" slot-scope="braceletNo">{{braceletNo ? braceletNo : "-"}}</span>
                        <span slot="consumeTime" slot-scope="consumeTime">{{consumeTime ? consumeTime : "-"}}</span>
                        <span slot="shopName" slot-scope="shopName">{{shopName ? shopName : "-"}}</span>
                        <span slot="cashier" slot-scope="cashier">{{cashier ? cashier : "-"}}</span>
                        <span slot="showName" slot-scope="showName">{{showName || "-"}}</span>
                    </a-table>
                </div>
                <div v-if="type == 2">
                    <template>
                        <span>该时间段入闸机人数：{{gatesEnteredNum}}，该时间段出闸机人数：{{gatesOutNum}}</span>
                        <a-button class="float-right mb16" @click="exportExcel()" :loading="loading">导出excel</a-button>
                    </template>
                    <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columnsBraceletAndGate" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                        <span slot="braceletNo" slot-scope="braceletNo">{{braceletNo ? braceletNo : "-"}}</span>
                    </a-table>
                </div>
                <div v-if="type == 3">
                    <template>
                        <a-button class="float-right mb16" @click="stateExport()" :loading="loading">导出excel</a-button>
                    </template>
                    <a-table :loading="loading" bordered :dataSource="dataSource" :columns="columnsBraceletConsume" :pagination="false" :rowKey="record => record.id">
                        <span slot="braceletNo" slot-scope="braceletNo">{{braceletNo ? braceletNo : "-"}}</span>
                    </a-table>
                </div>
            </div>
            <div v-else class="wrap-container-in text-center">
                暂无内容，请先浏览其他页面~
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import moment from "moment";
export default {
  name: "statementPage",
  components: {},
  props: {},
  data() {
    const columns = [
        {
            title: "票券ID",
            dataIndex: "ticketId",
        },
        {
            title: "票券内部标识",
            dataIndex: "ticketName"
        },
        {
            title: "票券展示名称",
            dataIndex: "showName",
            scopedSlots: { customRender: "showName" }
        },
        {
            title: "会员手机号",
            dataIndex: "account"
        },
        {
            title: "绑定手环",
            width: 150,
            dataIndex: "braceletNo",
            scopedSlots: { customRender: "braceletNo" }
        },
        {
            title: "消费时间",
            dataIndex: "consumeTime",
            scopedSlots: { customRender: "consumeTime" }
        },
        {
            title: "门店名称",
            dataIndex: "shopName",
            scopedSlots: { customRender: "shopName" }
        },
        {
            title: "操作人/收银员",
            dataIndex: "cashier",
            scopedSlots: { customRender: "cashier" }
        },
    ];
    const columnsBraceletAndGate = [
      {
        title: "记录ID",
        dataIndex: "id",
      },
      {
        title: "手环码",
        width: 150,
        dataIndex: "braceletNo"
      },
      {
        title: "会员手机号",
        dataIndex: "account"
      },
      {
        title: "消费时间",
        dataIndex: "consumeTime"
      },
      {
        title: "状态",
        dataIndex: "useType"
      },
      {
        title: "门店名称",
        dataIndex: "shopName"
      },
    ];
    const columnsBraceletConsume = [
      {
        title: "日期",
        dataIndex: "useDate",
      },
      {
        title: "绑定手环数",
        dataIndex: "dateBindNum"
      },
      {
        title: "入闸机人数",
        dataIndex: "dateInNum"
      },
      {
        title: "出闸机人数",
        dataIndex: "dateOutNum"
      },
      {
        title: "门店名称",
        dataIndex: "shopName"
      },
    ];
    return {
        columns,
        columnsBraceletAndGate,
        columnsBraceletConsume,
        dataSource: [],
        pagination: {
            showTotal: total => `共 ${total} 条数据`,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0,
            current: 1,
            pageSize: 20
        },
        shopList: [],
        type: 1,
        loading: false,
        initialValueDate: [],
        bindNum: 0,
        gatesEnteredNum: 0,
        gatesOutNum: 0,
        defaultActiveKey: 1
    };
  },
  computed: {},
  methods: {
        moment,
        callback(key) {
            this.type = key;
            this.dataSource = [];
            if(key == 3) {
                this.getBraceletConsumeList()
            }else {
                this.getList(true)
            }
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList(true)
        },
        handleReset () {
            this.form.resetFields();
        },
        searchBracelet() {
            this.pagination.current = 1;
            this.getBraceletConsumeList();
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        getList(flag = false) {
            this.form.validateFields((err, values) => {
                if (err) return;
                let valuesForm = {}
                const consumeTime = values['consumeTime'] ? values['consumeTime'] : []
                valuesForm.consumeStartTime = consumeTime.length > 0 ? consumeTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                valuesForm.consumeEndTime = consumeTime.length > 0 ? consumeTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                valuesForm.account = values.account
                valuesForm.braceletNo = values.braceletNo
                valuesForm.cashier = values.cashier
                valuesForm.shopId = values.shopId

                if(this.type == 1) {
                    valuesForm.ticketName = values.ticketName
                }else {
                    valuesForm.useType = values.useType
                }

                this.loading = true;
                this.$api.statement[(this.type == 1) ? 'braceletTicketList' : 'braceletAndGate']({
                        body: Object.assign(valuesForm, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                    })
                    .catch(err => {
                        this.loading = false;
                    })

                // 如果是分页切换调用方法，则不调用获取手环绑定数接口
                if(flag) return
                this.$api.statement[(this.type == 1) ? 'bindBraceletNum' : 'braceletAndGateNum']({
                        body: Object.assign(valuesForm, {
                            pageNum: 1,
                            pageSize: 999999
                        })
                    })
                    .then(res => {
                        if (this.type == 1) {
                            this.bindNum = res
                        }else if(this.type == 2) {
                            this.gatesEnteredNum = res.gatesEnteredNum
                            this.gatesOutNum = res.gatesOutNum
                            
                        }
                    });
            });
        },
        getBraceletConsumeList() {
            this.form.validateFields((err, values) => {
                if (err) return;
                let valuesForm = {}
                const useDate = values['useDate'] ? values['useDate'] : []
                valuesForm.startDate = useDate.length > 0 ? useDate[0].format('YYYY-MM-DD') : ''
                valuesForm.endDate = useDate.length > 0 ? useDate[1].format('YYYY-MM-DD') : ''

                this.loading = true;
                this.$api.statement.braceletConsume({
                        body: Object.assign(valuesForm, {
                            pageNum: 1,
                            pageSize: 99999999
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        this.dataSource = res.data;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            });
        },
        bindBraceletNum() {
            this.form.validateFields((err, values) => {
                if (err) return;
                let valuesForm = {}
                const useDate = values['useDate'] ? values['useDate'] : []
                valuesForm.startDate = useDate.length > 0 ? useDate[0].format('YYYY-MM-DD') : ''
                valuesForm.endDate = useDate.length > 0 ? useDate[1].format('YYYY-MM-DD') : ''

                this.$api.statement.braceletConsume({
                        body: Object.assign(valuesForm, {
                            pageNum: 1,
                            pageSize: 99999999
                        })
                    })
                    .then(res => {
                        this.dataSource = res.data;
                    });
            });
        },
        exportExcel() {
            this.form.validateFields((err, values) => {
                if (err) return;
                let valuesForm = {}
                const consumeTime = values['consumeTime'] ? values['consumeTime'] : []
                valuesForm.consumeStartTime = consumeTime.length > 0 ? consumeTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                valuesForm.consumeEndTime = consumeTime.length > 0 ? consumeTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                valuesForm.account = values.account
                valuesForm.braceletNo = values.braceletNo
                valuesForm.cashier = values.cashier
                valuesForm.shopId = values.shopId

                if(this.type == 1) {
                    valuesForm.ticketName = values.ticketName
                }else {
                    valuesForm.useType = values.useType
                }
                this.loading = true;
                this.$api.statement[(this.type == 1) ? 'braceletTicketExport' : 'braceletAndGateExport']({
                        body: Object.assign(valuesForm, {
                            pageNum: 1,
                            pageSize: 99999999
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let str = this.type == 1 ? '票券手环绑定信息' : '手环-闸机对应信息'
                        let name = str + '-' + moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false

                    }).catch(err => {
                        this.loading = false

                    })
            });
        },
        stateExport() {
            this.form.validateFields((err, values) => {
                if (err) return;
                const useDate = values['useDate'] ? values['useDate'] : []
                values.startDate = useDate.length > 0 ? useDate[0].format('YYYY-MM-DD') : ''
                values.endDate = useDate.length > 0 ? useDate[1].format('YYYY-MM-DD') : ''
                this.loading = true;
                this.$api.statement.braceletConsumeExport({
                        body: Object.assign(values, {
                            pageNum: 1,
                            pageSize: 99999999
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = '数据统计-' + moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false
                    }).catch(err => {
                        this.loading = false

                    })
            });
        },
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res;
            });
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {

        let start = moment(moment().format("YYYY/MM/DD")+' 00:00')
        let end = moment(moment().format("YYYY/MM/DD")+' 23:59')
        this.initialValueDate = [start,end]
    },
    mounted() {
        this.getShopList();
        if(this.getBtnByAuth('ticketBraceletExport')) {
            this.defaultActiveKey = 1
        this.getList();
        }else if(this.getBtnByAuth('braceletGateExport')) {
            this.defaultActiveKey = 2
        this.getList();
        }else if(this.getBtnByAuth('stateExport')) {
            this.defaultActiveKey = 3
            this.getBraceletConsumeList()
        }
    }
};
</script>
<style lang="scss"></style>